import HeroSlideshow from "@/components/yts/HeroSlideshow";
import { useLang } from "@/lib/i18n";

/** The photograph remains completely free of typography and overlays. */
export default function Hero() {
  const { lang } = useLang();
  const es = lang === "es";

  return (
    <section className="yts-cover w-full" aria-label={es ? "Portada de Ya Tú Sabes PR" : "Ya Tú Sabes PR cover"}>
      <div className="relative h-[clamp(185px,48vw,265px)] w-full overflow-hidden bg-[#111] sm:h-[315px] lg:h-[400px]">
        <HeroSlideshow />
      </div>
      <div className="border-b border-[#d8d4cd] bg-white px-4 pb-5 pt-5 text-[#171717] dark:border-white/15 dark:bg-[#171719] dark:text-white sm:px-8 sm:pb-7 sm:pt-6 lg:px-10">
        <div className="mx-auto max-w-[1180px]">
          <p className="mb-2 text-[9px] font-extrabold uppercase tracking-[.17em] text-[#aa4037] dark:text-[#f2a49b] sm:mb-3 sm:text-[10px]">{es ? "GUÍA LOCAL / PUERTO RICO" : "THE LOCAL GUIDE / PUERTO RICO"}</p>
          <h1 className="max-w-[1030px] text-balance text-[clamp(40px,8vw,78px)] font-extrabold leading-[.99] tracking-[-.053em]">
            {es ? "Explora Puerto Rico" : "Explore Puerto Rico"}<span className="text-[#E30613]">.</span>
          </h1>
          <p className="mt-3 max-w-[60ch] text-[13px] font-medium leading-[1.5] tracking-[-.012em] text-[#62615d] dark:text-white/70 sm:mt-4 sm:text-[16px]">
            {es ? "Lugares de aquí. Cultura viva. Mejores planes." : "Local places. Real culture. Better plans."}
          </p>
        </div>
      </div>
    </section>
  );
}
